/** Brand assets from fastwhistle-official-website/src/assets/img */
export const brandAssets = {
  logo: '/images/brand/fw-logo.webp',
  logoPng: '/images/brand/fw-logo.png',
  loader: '/images/brand/fw-loader.gif',
  favicon: '/assets/img/favicon.png',
  animatedLoader: '/assets/img/animated_favicon_no_tail.svg',
  deliveryMan: '/assets/img/delivery_man.png',
  multiDelivery: '/assets/img/multi_delivery.png',
  ctaBg: '/assets/img/cta-bg.png',
};
